'use client'

import { useEffect } from 'react'

import { gql } from '../../../../../__generated__/graphql/catalog'
import { RawHtmlSectionFragmentFragment } from '../../../../../__generated__/graphql/catalog/graphql'

export const rawHtmlQueryFragment = gql(`
  fragment RawHtmlSectionFragment on RawHtmlSection {
    __typename
    id
    html
  }
`)

const extractScripts = (rawHtml: string) => {
  let html = rawHtml
  const scriptTexts: string[] = []

  if (html) {
    // Regex + HTML https://stackoverflow.com/a/1732454/161182
    const tags = html.match(/<script[^>]*>[\s\S]*?<\/script>/g)
    if (tags) {
      tags.forEach(tag => {
        const text = tag.match(/<script[^>]*>([\s\S]*)<\/script>/)![1]
        if (text) scriptTexts.push(text)
        html = html.replace(tag, '')
      })
    }
  }

  return {
    htmlWithoutScripts: html,
    scriptTexts,
  }
}

const ContentfulRawHtmlScripts = ({ scriptTexts }: { scriptTexts: string[] }) => {
  useEffect(() => {
    scriptTexts.forEach(text => {
      const node = document.createElement('script')
      node.innerText = text
      document.body.appendChild(node)
    })
    // TODO: Fix this auto-generated suppression.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

type ContentfulRawHtmlProps = Omit<RawHtmlSectionFragmentFragment, '__typename' | 'id'> & {
  className?: string
}

export const ContentfulRawHtml = ({ html, className }: ContentfulRawHtmlProps) => {
  const { htmlWithoutScripts, scriptTexts } = extractScripts(html)

  return (
    <>
      <ContentfulRawHtmlScripts scriptTexts={scriptTexts} />
      <div className={className} dangerouslySetInnerHTML={{ __html: htmlWithoutScripts }} />
    </>
  )
}
